import React from "react";
import { SideSheet } from "@douyinfe/semi-ui";
import ContactsPanel from "./ContactsPanel";

interface ContactsSideSheetProps {
  visible: boolean;
  onClose: () => void;
}

export default function ContactsSideSheet({ visible, onClose }: ContactsSideSheetProps) {
  return (
    <SideSheet
      visible={visible}
      onCancel={onClose}
      width={700}
      style={{ top: 60 }}
      headerStyle={{ display: "none" }}
    >
      <div style={{ height: "calc(100vh - 60px)" }}>
        <ContactsPanel showHeader={true} leftWidth={350} />
      </div>
    </SideSheet>
  );
}
